import { Reducers } from '@sda/enums/store';
import { SDK } from './helpers/sdk';
import { SDKFactory } from './helpers/sdk.factory';
import type { Badge, Category, Country } from '@sda/interfaces/category';

const options = { reducerName: Reducers.CATEGORIES };

/**
 * SDK Class to interact with Firestore Categories.
 */
export class Categories extends SDK<never> {
  /**
   * Returns a FirestoreBaseClass instance for the ActTypes collection
   * @return {SDK<Category>}
   */
  ActTypes(): SDK<Category> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Category>(clientData, Schema.Categories_ActTypes, options);
  }

  /**
   * Returns a FirestoreBaseClass instance for the Genres collection
   * @return {SDK<Category>}
   */
  Badges(): SDK<Badge> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Badge>(clientData, Schema.Categories_Badges, options);
  }

  /**
   * Returns a FirestoreBaseClass instance for the MusicTypes collection
   * @return {SDK<Category>}
   */
  MusicTypes(): SDK<Category> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Category>(clientData, Schema.Categories_MusicTypes, options);
  }

  /**
   * Returns a FirestoreBaseClass instance for the ShowSalesRestrictions collection
   * @return {SDK<Category>}
   */
  ShowSalesRestrictions(): SDK<Category> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Category>(clientData, Schema.Categories_ShowSalesRestrictions, options);
  }

  /**
   * Returns a FirestoreBaseClass instance for the Countries collection
   * @return {SDK<Country>}
   */
  Countries(): SDK<Country> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Country>(clientData, Schema.Categories_Countries, options);
  }

  /**
   * Returns a FirestoreBaseClass instance for the Disabilities collection
   * @return {SDK<Category>}
   */
  Disabilities(): SDK<Category> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Category>(clientData, Schema.Categories_Disabilities, options);
  }

  /**
   * Returns a FirestoreBaseClass instance for the Genders collection
   * @return {SDK<Category>}
   */
  Genders(): SDK<Category> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Category>(clientData, Schema.Categories_Genders, options);
  }

  /**
   * Returns a FirestoreBaseClass instance for the Genres collection
   * @return {SDK<Category>}
   */
  Genres(): SDK<Category> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Category>(clientData, Schema.Categories_Genres, options);
  }

  /**
   * Returns a FirestoreBaseClass instance for the Identities collection
   * @return {SDK<Category>}
   */
  Identities(): SDK<Category> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Category>(clientData, Schema.Categories_Identities, options);
  }

  /**
   * Returns a FirestoreBaseClass instance for the Sexualities collection
   * @return {SDK<Category>}
   */
  Sexualities(): SDK<Category> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Category>(clientData, Schema.Categories_Sexualities, options);
  }

  /**
   * Returns a FirestoreBaseClass instance for the VenueTypes collection
   * @return {SDK<Category>}
   */
  VenueTypes(): SDK<Category> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Category>(clientData, Schema.Categories_VenueTypes, options);
  }

  /**
   * Returns a FirestoreBaseClass instance for the VenueSizes collection
   * @return {SDK<Category>}
   */
  VenueSizes(): SDK<Category> {
    const { clientData, Schema } = this.fsh;

    return SDKFactory<Category>(clientData, Schema.Categories_VenueSizes, options);
  }
}
